// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as DTS_Types from "../DTS.Types/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Ouroboros_Programs_Routes from "../Ouroboros.Programs.Routes/index.js";
import * as Ouroboros_Programs_TsBridgeHelpers from "../Ouroboros.Programs.TsBridgeHelpers/index.js";
import * as Ouroboros_Services_Clients_Interop_IO from "../Ouroboros.Services.Clients.Interop.IO/index.js";
import * as Ouroboros_Services_Clients_Interop_Types from "../Ouroboros.Services.Clients.Interop.Types/index.js";
import * as TsBridge_Class from "../TsBridge.Class/index.js";
import * as TsBridge_DefaultImpls from "../TsBridge.DefaultImpls/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(TsBridge_Monad.bindTsBridgeM);
var tsBridgeRecord = /* #__PURE__ */ TsBridge_Class.tsBridgeRecord(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecord1()(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecordRLCons(/* #__PURE__ */ TsBridge_Class.tsBridgeByTok(TsBridge_Class.tsBridgeBoolean))(TsBridge_DefaultImpls.tsBridgeRecordRLNil)({
    reflectSymbol: function () {
        return "success";
    }
})));
var tsBridge = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeTaskTs(tsBridgeRecord));
var tsBridge1 = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeIOts(tsBridgeRecord));
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var tsBridge2 = /* #__PURE__ */ TsBridge_Class.tsBridge(TsBridge_Class.tsBridgeString);
var tsBridge3 = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeIOts(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeOptionTs(TsBridge_Class.tsBridgeString)));
var tsBridge4 = /* #__PURE__ */ TsBridge_Class.tsBridge(Ouroboros_Programs_Routes.tsBridgeRoute);
var tsBridge5 = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeIOts(TsBridge_Class.tsBridgeInt));
var tsBridge6 = /* #__PURE__ */ TsBridge_Class.tsBridge(Ouroboros_Services_Clients_Interop_Types.tsBridgeBlob);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var TaskRunner = function (x) {
    return x;
};
var TaskHandler = function (x) {
    return x;
};
var StorageSet = function (x) {
    return x;
};
var StorageRemove = function (x) {
    return x;
};
var StorageGet = function (x) {
    return x;
};
var StateUpdate = function (x) {
    return x;
};
var StateRead = function (x) {
    return x;
};
var StateHandle = function (x) {
    return x;
};
var RouteBuilder = function (x) {
    return x;
};
var RefreshIntent = function (x) {
    return x;
};
var OptionStateHandle = function (x) {
    return x;
};
var Navigate = function (x) {
    return x;
};
var Fetch = function (x) {
    return x;
};
var EmitOnRouteChangeTask = function (x) {
    return x;
};
var EmitOnRouteChange = function (x) {
    return x;
};
var EmitOnMount = function (x) {
    return x;
};
var EmitOnInit = function (x) {
    return x;
};
var EmitOnAction = function (x) {
    return x;
};
var ControllerAction = function (x) {
    return x;
};
var ClockNow = function (x) {
    return x;
};
var ClientFetch = function (x) {
    return x;
};
var BlobHandler = function (x) {
    return x;
};
var tsBridgeTaskRunner = {
    tsBridge: function (v) {
        return bind(tsBridge(Type_Proxy["Proxy"].value))(function (argType) {
            return bind(tsBridge1(Type_Proxy["Proxy"].value))(function (retType) {
                var fnType = Ouroboros_Programs_TsBridgeHelpers.functionType([ new DTS_Types.TsFnArg(new DTS_Types.TsName("task"), argType) ])(retType);
                return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(fnType)("TaskRunner")("__brandTaskRunner"));
            });
        });
    }
};
var tsBridgeTaskHandler = function (dictTsBridge) {
    var tsBridge7 = TsBridge_Class.tsBridge(dictTsBridge);
    return {
        tsBridge: function (v) {
            return bind(tsBridge7(Type_Proxy["Proxy"].value))(function (argType) {
                return bind(tsBridge(Type_Proxy["Proxy"].value))(function (retType) {
                    var fnType = Ouroboros_Programs_TsBridgeHelpers.functionType([ new DTS_Types.TsFnArg(new DTS_Types.TsName("value"), argType) ])(retType);
                    return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(fnType)("TaskHandler")("__brandTaskHandler"));
                });
            });
        }
    };
};
var tsBridgeStorageSet = {
    tsBridge: function (v) {
        return bind(tsBridge2(Type_Proxy["Proxy"].value))(function (keyType) {
            return bind(tsBridge2(Type_Proxy["Proxy"].value))(function (valueType) {
                var payloadType = new DTS_Types.TsTypeRecord([ new DTS_Types.TsRecordField("key", {
                    readonly: true,
                    optional: false
                }, keyType), new DTS_Types.TsRecordField("value", {
                    readonly: true,
                    optional: false
                }, valueType) ]);
                return bind(tsBridge1(Type_Proxy["Proxy"].value))(function (retType) {
                    var fnType = Ouroboros_Programs_TsBridgeHelpers.functionType([ new DTS_Types.TsFnArg(new DTS_Types.TsName("payload"), payloadType) ])(retType);
                    return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(fnType)("StorageSet")("__brandStorageSet"));
                });
            });
        });
    }
};
var tsBridgeStorageRemove = {
    tsBridge: function (v) {
        return bind(tsBridge2(Type_Proxy["Proxy"].value))(function (argType) {
            return bind(tsBridge1(Type_Proxy["Proxy"].value))(function (retType) {
                var fnType = Ouroboros_Programs_TsBridgeHelpers.functionType([ new DTS_Types.TsFnArg(new DTS_Types.TsName("key"), argType) ])(retType);
                return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(fnType)("StorageRemove")("__brandStorageRemove"));
            });
        });
    }
};
var tsBridgeStorageGet = {
    tsBridge: function (v) {
        return bind(tsBridge2(Type_Proxy["Proxy"].value))(function (argType) {
            return bind(tsBridge3(Type_Proxy["Proxy"].value))(function (retType) {
                var fnType = Ouroboros_Programs_TsBridgeHelpers.functionType([ new DTS_Types.TsFnArg(new DTS_Types.TsName("key"), argType) ])(retType);
                return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(fnType)("StorageGet")("__brandStorageGet"));
            });
        });
    }
};
var tsBridgeStateUpdate = function (dictTsBridge) {
    var tsBridge7 = TsBridge_Class.tsBridge(dictTsBridge);
    return {
        tsBridge: function (v) {
            return bind(tsBridge7(Type_Proxy["Proxy"].value))(function (argType) {
                return bind(tsBridge1(Type_Proxy["Proxy"].value))(function (retType) {
                    var fnType = Ouroboros_Programs_TsBridgeHelpers.functionType([ new DTS_Types.TsFnArg(new DTS_Types.TsName("value"), argType) ])(retType);
                    return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(fnType)("StateUpdate")("__brandStateUpdate"));
                });
            });
        }
    };
};
var tsBridgeStateRead = function (dictTsBridge) {
    var tsBridge7 = TsBridge_Class.tsBridge(dictTsBridge);
    return {
        tsBridge: function (v) {
            return bind(tsBridge7(Type_Proxy["Proxy"].value))(function (valueType) {
                return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(valueType)("StateRead")("__brandStateRead"));
            });
        }
    };
};
var tsBridgeStateHandle = function (dictTsBridge) {
    var tsBridge7 = TsBridge_Class.tsBridge(tsBridgeStateRead(dictTsBridge));
    var tsBridge8 = TsBridge_Class.tsBridge(tsBridgeStateUpdate(dictTsBridge));
    return {
        tsBridge: function (v) {
            return bind(tsBridge7(Type_Proxy["Proxy"].value))(function (readType) {
                return bind(tsBridge8(Type_Proxy["Proxy"].value))(function (setType) {
                    return pure(new DTS_Types.TsTypeRecord([ new DTS_Types.TsRecordField("read", {
                        readonly: true,
                        optional: false
                    }, readType), new DTS_Types.TsRecordField("set", {
                        readonly: true,
                        optional: false
                    }, setType) ]));
                });
            });
        }
    };
};
var tsBridgeRouteBuilder = function (dictTsBridge) {
    var tsBridge7 = TsBridge_Class.tsBridge(dictTsBridge);
    return {
        tsBridge: function (v) {
            return bind(tsBridge7(Type_Proxy["Proxy"].value))(function (argType) {
                return bind(tsBridge2(Type_Proxy["Proxy"].value))(function (retType) {
                    var fnType = Ouroboros_Programs_TsBridgeHelpers.functionType([ new DTS_Types.TsFnArg(new DTS_Types.TsName("value"), argType) ])(retType);
                    return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(fnType)("RouteBuilder")("__brandRouteBuilder"));
                });
            });
        }
    };
};
var tsBridgeRefreshIntent = function (dictTsBridge) {
    var tsBridgeTaskEitherTs = Ouroboros_Services_Clients_Interop_Types.tsBridgeTaskEitherTs(dictTsBridge);
    return function (dictTsBridge1) {
        var tsBridge7 = TsBridge_Class.tsBridge(tsBridgeTaskEitherTs(dictTsBridge1));
        return {
            tsBridge: function (v) {
                return bind(tsBridge7(Type_Proxy["Proxy"].value))(function (valueType) {
                    return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(valueType)("RefreshIntent")("__brandRefreshIntent"));
                });
            }
        };
    };
};
var tsBridgeOptionStateHandle = function (dictTsBridge) {
    var tsBridgeOptionTs = Ouroboros_Services_Clients_Interop_Types.tsBridgeOptionTs(dictTsBridge);
    var tsBridge7 = TsBridge_Class.tsBridge(tsBridgeStateRead(tsBridgeOptionTs));
    var tsBridge8 = TsBridge_Class.tsBridge(tsBridgeStateUpdate(dictTsBridge));
    var tsBridge9 = TsBridge_Class.tsBridge(tsBridgeStateUpdate(tsBridgeOptionTs));
    return {
        tsBridge: function (v) {
            return bind(tsBridge7(Type_Proxy["Proxy"].value))(function (readType) {
                return bind(tsBridge8(Type_Proxy["Proxy"].value))(function (setSomeType) {
                    return bind(tsBridge9(Type_Proxy["Proxy"].value))(function (setMaybeType) {
                        return pure(new DTS_Types.TsTypeRecord([ new DTS_Types.TsRecordField("read", {
                            readonly: true,
                            optional: false
                        }, readType), new DTS_Types.TsRecordField("setMaybe", {
                            readonly: true,
                            optional: false
                        }, setMaybeType), new DTS_Types.TsRecordField("setSome", {
                            readonly: true,
                            optional: false
                        }, setSomeType) ]));
                    });
                });
            });
        }
    };
};
var tsBridgeNavigate = {
    tsBridge: function (v) {
        return bind(tsBridge4(Type_Proxy["Proxy"].value))(function (argType) {
            return bind(tsBridge1(Type_Proxy["Proxy"].value))(function (retType) {
                var fnType = Ouroboros_Programs_TsBridgeHelpers.functionType([ new DTS_Types.TsFnArg(new DTS_Types.TsName("route"), argType) ])(retType);
                return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(fnType)("Navigate")("__brandNavigate"));
            });
        });
    }
};
var tsBridgeFetch = function (dictTsBridge) {
    var tsBridgeTaskEitherTs = Ouroboros_Services_Clients_Interop_Types.tsBridgeTaskEitherTs(dictTsBridge);
    return function (dictTsBridge1) {
        var tsBridge7 = TsBridge_Class.tsBridge(tsBridgeTaskEitherTs(dictTsBridge1));
        return {
            tsBridge: function (v) {
                return bind(tsBridge7(Type_Proxy["Proxy"].value))(function (valueType) {
                    return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(valueType)("Fetch")("__brandFetch"));
                });
            }
        };
    };
};
var tsBridgeEmitOnRouteChange = function (dictTsBridge) {
    var tsBridge7 = TsBridge_Class.tsBridge(dictTsBridge);
    return {
        tsBridge: function (v) {
            return bind(tsBridge7(Type_Proxy["Proxy"].value))(function (argType) {
                return bind(tsBridge(Type_Proxy["Proxy"].value))(function (retType) {
                    var fnType = Ouroboros_Programs_TsBridgeHelpers.functionType([ new DTS_Types.TsFnArg(new DTS_Types.TsName("value"), argType) ])(retType);
                    return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(fnType)("EmitOnRouteChangeTask")("__brandEmitOnRouteChangeTask"));
                });
            });
        }
    };
};
var tsBridgeEmitOnRouteChange1 = function (dictTsBridge) {
    var tsBridge7 = TsBridge_Class.tsBridge(dictTsBridge);
    return {
        tsBridge: function (v) {
            return bind(tsBridge7(Type_Proxy["Proxy"].value))(function (argType) {
                return bind(tsBridge1(Type_Proxy["Proxy"].value))(function (retType) {
                    var fnType = Ouroboros_Programs_TsBridgeHelpers.functionType([ new DTS_Types.TsFnArg(new DTS_Types.TsName("value"), argType) ])(retType);
                    return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(fnType)("EmitOnRouteChange")("__brandEmitOnRouteChange"));
                });
            });
        }
    };
};
var tsBridgeEmitOnMount = {
    tsBridge: function (v) {
        return bind(tsBridge1(Type_Proxy["Proxy"].value))(function (valueType) {
            return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(valueType)("EmitOnMount")("__brandEmitOnMount"));
        });
    }
};
var tsBridgeEmitOnInit = {
    tsBridge: function (v) {
        return bind(tsBridge1(Type_Proxy["Proxy"].value))(function (valueType) {
            return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(valueType)("EmitOnInit")("__brandEmitOnInit"));
        });
    }
};
var tsBridgeEmitOnAction = function (dictTsBridge) {
    var tsBridge7 = TsBridge_Class.tsBridge(dictTsBridge);
    return {
        tsBridge: function (v) {
            return bind(tsBridge7(Type_Proxy["Proxy"].value))(function (argType) {
                return bind(tsBridge1(Type_Proxy["Proxy"].value))(function (retType) {
                    var fnType = Ouroboros_Programs_TsBridgeHelpers.functionType([ new DTS_Types.TsFnArg(new DTS_Types.TsName("value"), argType) ])(retType);
                    return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(fnType)("EmitOnAction")("__brandEmitOnAction"));
                });
            });
        }
    };
};
var tsBridgeControllerAction = {
    tsBridge: function (v) {
        return bind(tsBridge1(Type_Proxy["Proxy"].value))(function (valueType) {
            return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(valueType)("ControllerAction")("__brandControllerAction"));
        });
    }
};
var tsBridgeClockNow = {
    tsBridge: function (v) {
        return bind(tsBridge5(Type_Proxy["Proxy"].value))(function (valueType) {
            return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(valueType)("ClockNow")("__brandClockNow"));
        });
    }
};
var tsBridgeClientFetch = function (dictTsBridge) {
    var tsBridgeFetch1 = tsBridgeFetch(dictTsBridge);
    return function (dictTsBridge1) {
        var tsBridge7 = TsBridge_Class.tsBridge(tsBridgeFetch1(dictTsBridge1));
        return {
            tsBridge: function (v) {
                return bind(tsBridge7(Type_Proxy["Proxy"].value))(function (valueType) {
                    return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(valueType)("ClientFetch")("__brandClientFetch"));
                });
            }
        };
    };
};
var tsBridgeBlobHandler = {
    tsBridge: function (v) {
        return bind(tsBridge6(Type_Proxy["Proxy"].value))(function (blobType) {
            return bind(tsBridge2(Type_Proxy["Proxy"].value))(function (titleType) {
                return bind(tsBridge1(Type_Proxy["Proxy"].value))(function (retType) {
                    var fnType = Ouroboros_Programs_TsBridgeHelpers.functionType([ new DTS_Types.TsFnArg(new DTS_Types.TsName("blob"), blobType), new DTS_Types.TsFnArg(new DTS_Types.TsName("title"), titleType) ])(retType);
                    return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(fnType)("BlobHandler")("__brandBlobHandler"));
                });
            });
        });
    }
};
var stateHandleSet = function (v) {
    return v.set;
};
var stateHandleRead = function (v) {
    return v.read;
};
var runTaskRunner = function (v) {
    return v;
};
var runTaskHandler = function (v) {
    return v;
};
var runStateUpdate = function (v) {
    return v;
};
var runRouteBuilder = function (v) {
    return v;
};
var runRefreshIntent = function (v) {
    return v;
};
var runControllerAction = function (v) {
    return v;
};
var runBlobHandler = function (v) {
    return v;
};
var optionStateHandleSetSome = function (v) {
    return v.setSome;
};
var optionStateHandleSetMaybe = function (v) {
    return v.setMaybe;
};
var optionStateHandleRead = function (v) {
    return v.read;
};
var mkTaskRunner = TaskRunner;
var mkTaskHandler = TaskHandler;
var mkStorageSet = StorageSet;
var mkStorageRemove = StorageRemove;
var mkStorageGet = StorageGet;
var mkStateHandle = function (read) {
    return function (set) {
        return {
            read: read,
            set: set
        };
    };
};
var mkRouteBuilder = RouteBuilder;
var mkRefreshIntent = RefreshIntent;
var mkOptionStateHandle = function (read) {
    return function (setSome) {
        return function (setMaybe) {
            return {
                read: read,
                setSome: setSome,
                setMaybe: setMaybe
            };
        };
    };
};
var mkNavigate = Navigate;
var mkControllerAction = ControllerAction;
var runNavigateAction = function (v) {
    return function (path) {
        return mkControllerAction(v(path));
    };
};
var sequenceControllerActions = function (actions) {
    return mkControllerAction(Ouroboros_Services_Clients_Interop_IO.sequenceOk(map(runControllerAction)(actions)));
};
var mkClockNow = ClockNow;
var mkBlobHandler = BlobHandler;
export {
    StateRead,
    StateUpdate,
    runStateUpdate,
    mkStateHandle,
    stateHandleRead,
    stateHandleSet,
    mkOptionStateHandle,
    TaskRunner,
    mkTaskRunner,
    runTaskRunner,
    TaskHandler,
    mkTaskHandler,
    runTaskHandler,
    RouteBuilder,
    mkRouteBuilder,
    runRouteBuilder,
    BlobHandler,
    mkBlobHandler,
    runBlobHandler,
    ControllerAction,
    mkControllerAction,
    ClockNow,
    mkClockNow,
    StorageGet,
    mkStorageGet,
    StorageSet,
    mkStorageSet,
    StorageRemove,
    mkStorageRemove,
    Navigate,
    mkNavigate,
    runNavigateAction,
    optionStateHandleRead,
    optionStateHandleSetSome,
    optionStateHandleSetMaybe,
    EmitOnAction,
    EmitOnMount,
    EmitOnInit,
    EmitOnRouteChange,
    EmitOnRouteChangeTask,
    Fetch,
    ClientFetch,
    RefreshIntent,
    mkRefreshIntent,
    runRefreshIntent,
    runControllerAction,
    sequenceControllerActions,
    tsBridgeStateRead,
    tsBridgeStateUpdate,
    tsBridgeTaskRunner,
    tsBridgeTaskHandler,
    tsBridgeRouteBuilder,
    tsBridgeBlobHandler,
    tsBridgeControllerAction,
    tsBridgeClockNow,
    tsBridgeStorageGet,
    tsBridgeStorageSet,
    tsBridgeStorageRemove,
    tsBridgeNavigate,
    tsBridgeEmitOnAction,
    tsBridgeEmitOnMount,
    tsBridgeEmitOnInit,
    tsBridgeEmitOnRouteChange1,
    tsBridgeEmitOnRouteChange,
    tsBridgeFetch,
    tsBridgeClientFetch,
    tsBridgeRefreshIntent,
    tsBridgeStateHandle,
    tsBridgeOptionStateHandle
};
//# sourceMappingURL=index.js.map
